module.exports = __webpack_public_path__ + "img/tocci.eb731ee1.jpg";